import {
  Modal,
  ModalOverlay,
  ModalBody,
  ModalCloseButton,
  ModalHeader,
  ModalContent,
  HStack,
  Text,
  ModalFooter,
} from '@chakra-ui/react'
import Status from 'features/common/status'
import React from 'react'
import { WOCalendar } from './calendar'

interface Props {
  isOpen: any
  onClose: any
  workOrder: any
  workOrderFormReturn: any
}
export const CalendarModal: React.FC<Props> = (props): JSX.Element => {
  const { isOpen, onClose, workOrderFormReturn, workOrder } = props
  const focusRef = React.useRef<any>(null)

  return (
    <>
      <Modal isOpen={isOpen} closeOnOverlayClick={false} onClose={onClose} size="4xl" initialFocusRef={focusRef}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader bg="white">
            <HStack spacing={4}>
              <HStack fontSize="16px" fontWeight={500}>
                <Text borderRight="1px solid #E2E8F0" lineHeight="22px" h="22px" pr={2}>
                  WO {workOrder?.id}
                </Text>
                <Text lineHeight="22px" h="22px">
                  Calendar
                </Text>
              </HStack>

              <Status value={workOrder?.statusLabel} id={workOrder?.statusLabel} />
            </HStack>
          </ModalHeader>

          <ModalCloseButton _focus={{ outline: 'none' }} _hover={{ bg: 'blue.50' }} />

          <ModalBody>
            <WOCalendar workOrder={workOrder} workOrderFormReturn={workOrderFormReturn} closeModal={onClose} />
          </ModalBody>
          <ModalFooter></ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}
